// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumb_root__2D5tn","container":"breadcrumb_container__cu7Rd"};